export default class Accordion {
    static init() {
        const isNeosBackend = document.body.classList.contains('neos-backend');
        if (isNeosBackend) {
            return;
        }

        Array.prototype.forEach.call(document.querySelectorAll('.accordion'), el => {
            new Accordion(el);
        });
    }

    constructor(element) {
        if (!element) return;
        this.element = element;
        this.items = [];
        let accordionItems = this.element.querySelectorAll('.accordion__item');

        Array.prototype.forEach.call(accordionItems, el => {
            let accordionItem = new AccordionItem(el);
            this.items.push(accordionItem);
        });

        this.items.forEach(item => {
            item.accordionItemHeadingNode.addEventListener('click', () => {
                if (item.isActive) {
                    item.makeInactive();
                } else {
                    if (this.getActiveItem()) {
                        this.getActiveItem().makeInactive();
                    }
                    item.makeActive();
                }
            });
        });
    }

    getActiveItem() {
        return this.items.find(item => item.isActive);
    }
}

class AccordionItem {
    constructor(element) {
        this.accordionItemNode = element;
        this.activeClass = 'accordion__item--active';
        this.activeSelector = '.' + this.activeClass;
        this.isActive = this.accordionItemNode.classList.contains(this.activeClass) || false;
        this.accordionItemHeadingNode = this.accordionItemNode.querySelector('.accordion__item-heading');
        this.accordionItemContentNode = this.accordionItemNode.querySelector('.accordion__item-content');
        this.accordionItemImageNode = this.accordionItemNode.querySelector('.accordion__item-image');
        this.accordionItemTextNode = this.accordionItemNode.querySelector('.accordion__item-text');
        let timeout = 350;

        if (this.isActive) {
            setTimeout(() => {
                if (!this.arrow && !this.isContentFit(this.accordionItemTextNode, this.accordionItemImageNode)) {
                    this.addArrow();
                }
            }, timeout);
        }

        this.accordionItemHeadingNode.addEventListener('click', (e) => {
            // scroll to item on mobile
            if (this.isMobile()) {
                let mobileOffset = 0;
                this.accordionItemContentNode.scrollTo({top: 0});

                setTimeout(() => {
                    let headerHeight = document.querySelector('.header__inner') ? document.querySelector('.header__inner').getBoundingClientRect().height : 0;

                    window.scrollTo({
                        top: mobileOffset - headerHeight + this.accordionItemHeadingNode.getBoundingClientRect().y + window.pageYOffset,
                        behavior: "smooth"
                    });
                }, timeout);
            }

            // render arrow if content is not fit
            setTimeout(() => {
                if (!this.arrow && !this.isContentFit(this.accordionItemTextNode, this.accordionItemImageNode)) {
                    this.addArrow();
                }
            }, timeout);
        });

        if (!this.arrow && this.isActive && !this.isContentFit(this.accordionItemTextNode, this.accordionItemImageNode)) {
            this.addArrow();
        }

        if (!this.isContentFit(this.accordionItemTextNode, this.accordionItemImageNode)) {
            this.addOverlapClassIfNotEndScrolled();
        }
        this.accordionItemContentNode.addEventListener('scroll', () => requestAnimationFrame(() => {
            this.addOverlapClassIfNotEndScrolled();
        }));
    }

    addOverlapClassIfNotEndScrolled() {
        if (this.isEndScrolled()) {
            this.accordionItemNode.classList.remove('is-overlap');
        } else {
            this.accordionItemNode.classList.add('is-overlap');
        }
    }

    isEndScrolled() {
        return this.accordionItemContentNode.scrollHeight - (this.accordionItemContentNode.getBoundingClientRect().height + this.accordionItemContentNode.scrollTop) < 10;
    }

    /**
     * el:HMTLElement (.accordion__item-text)
     * @returns {boolean}
     * */
    isContentFit(...elements) {
        if (!elements) return false;
        const aggregatedHeight = elements.reduce((acc, el) => acc + (el ? el.getBoundingClientRect().height : 0), 0);
        return Math.round(aggregatedHeight) <= window.innerHeight / 2;
    }

    isActiveItem(el) {
        if (!el) return;
        return this.isActive;
    }

    makeActive() {
        this.isActive = true;
        this.accordionItemNode.classList.add(this.activeClass);
    }

    makeInactive() {
        this.isActive = false;
        this.accordionItemNode.classList.remove(this.activeClass);
    }

    addArrow() {
        this.arrow = new AccordionContentArrow(this.accordionItemNode);
        this.arrow.render();
        this.arrow.show();

        this.accordionItemNode.addEventListener('scroll', e => {
            if (!this.isContentFit(this.accordionItemTextNode, this.accordionItemImageNode)) {
                this.arrow.show();
            } else {
                this.arrow.hide();
            }
        });
    }

    isMobile() {
        return window.innerWidth < 768;
    }
}

class AccordionContentArrow {
    constructor(element) {
        if (!element) return;

        this.arrowWrapper = element;
        this.arrowNode = document.createElement("SPAN");
        this.itemContentNode = this.arrowWrapper.querySelector('.accordion__item-content');
    }

    render() {
        this.arrowNode.classList.add('arrow');
        this.arrowWrapper.append(this.arrowNode);

        this.arrowNode.addEventListener('click', () => {
            this.itemContentNode.scrollTo({
                top: this.itemContentNode.scrollTop + this.itemContentNode.getBoundingClientRect().height - 40,
                behavior: "smooth"
            });
        });
    }

    show() {
        this.arrowWrapper.classList.add('is-overlap');
    }

    hide() {
        this.arrowWrapper.classList.remove('is-overlap');
    }
}
